import { HiddenPanelActionType } from "../Controls/FormParts/HiddenPanel/Store/HiddenPanelActions";
import { PanelTabType, PanelType } from "../Controls/FormParts/Panel/PanelTypes";
import {
    FormSaveStatusActionType,
    FormSavingStatus,
} from "../Controls/FormParts/Panel/FormSaveStatus/Store/FormSaveStatusActions";
import { INNActionType } from "../Controls/ValueEditors/INN/Store/INNActions";
import { ActionPanelActionType } from "../Controls/FormParts/Panel/ActionPanel/Store/ActionPanelActions";

import { FullFormAction } from "./Core/Store/FullFormAction";
import { FormActionType } from "./Form/Store/FormActions";

export interface FormVisualState {
    isWidePanel: boolean;
    panelState: PanelType;
    panelActiveTab: PanelTabType;
    savingStatus: FormSavingStatus;

    isFufDownloading?: boolean;
    isInnerDownloading?: boolean;

    isFrozenPanel?: boolean;
    isFrozenPopup?: boolean;
    isPopupPanel?: boolean;
    isFormReloading?: boolean;

    isHideOrgName?: boolean;
}

export function formVisualStateReducer(state: FormVisualState, action: FullFormAction): FormVisualState {
    switch (action.type) {
        case FormSaveStatusActionType.SetSavingStatus:
            return { ...state, savingStatus: action.payload.status };
        case FormActionType.SetFormReloading:
            return { ...state, isFormReloading: action.payload.isFormReloading };

        case ActionPanelActionType.BeginDownloadFuf:
            return { ...state, isFufDownloading: true };
        case ActionPanelActionType.EndDownloadFuf:
            return { ...state, isFufDownloading: false };
        case ActionPanelActionType.BeginDownloadInner:
            return { ...state, isInnerDownloading: true };
        case ActionPanelActionType.EndDownloadInner:
            return { ...state, isInnerDownloading: false };

        case HiddenPanelActionType.SetWidePanel: {
            return {
                ...state,
                isWidePanel: action.payload,
            };
        }
        case HiddenPanelActionType.SetPanelState: {
            if (state.isFrozenPanel) {
                return state;
            }

            return {
                ...state,
                panelState: action.payload,
            };
        }
        case HiddenPanelActionType.SetPopupPanel: {
            if (state.isFrozenPopup && action.payload.isFrozenPopup !== false) {
                return state;
            }

            const nextState: FormVisualState = {
                ...state,
                isPopupPanel: action.payload.isPopupPanel,
            };

            if (action.payload.isFrozenPopup !== undefined) {
                nextState.isFrozenPopup = action.payload.isFrozenPopup;
            }

            return nextState;
        }
        case HiddenPanelActionType.FrozenPanel: {
            return {
                ...state,
                isFrozenPanel: action.payload,
            };
        }
        case HiddenPanelActionType.SetPanelActiveTab: {
            return {
                ...state,
                panelActiveTab: action.payload,
            };
        }

        case INNActionType.SetHiddenOrgName: {
            return state.isHideOrgName === action.payload ? state : { ...state, isHideOrgName: action.payload };
        }

        default:
            return state;
    }
}
